import {DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import {Dialog2} from "../../../misc/Dialog2";
import {SmoothActionBar} from "../../../misc/SmoothActionBar";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../misc/SyncedRef";


export function Archive(props: {
    onDone(): void;
    onArchive(): Promise<void>
}) {
    const archiveRef = useSyncedRef(props.onArchive);
    const doneRef = useSyncedRef(props.onDone);

    const action = useAsyncAction(async () => {
        await archiveRef.current();
        doneRef.current();
    }, []);

    const submit = () => action.callback(null);

    return (
        <Dialog2 open onClose={props.onDone} onEnterPress={submit}>
            <DialogTitle>
                Confirm Deletion
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure you want to delete this? You cannot undo this action.
                </DialogContentText>
            </DialogContent>
            <SmoothActionBar
                loading={action.loading}
                error={action.error}
                actionName="Delete"
                onCancel={props.onDone}
                onSubmit={submit}
            />
        </Dialog2>
    )
}